import React from 'react';
import AssemblyResultsResume from '../pages/AssemblyResultsResume';

export const assemblyResultsResumeRoutePage = {
  component: <AssemblyResultsResume />,
  route: '/resultados-assembleia-resumido',
};
